/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:absolute;right:1rem;z-index:99;cursor:pointer}.user-info-wrapper[_ngcontent-%COMP%]{position:relative}.user-root-title[_ngcontent-%COMP%]{font-size:14px}.user-root-title[_ngcontent-%COMP%]::after{content:' \u25BE'}.user-level-content[_ngcontent-%COMP%]{position:absolute;background:#fff;font-size:14px;right:0}.user-level-content[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:pointer;display:block;padding:6px 12px;color:#878787;font-size:14px;white-space:nowrap;text-decoration:none}.user-level-content[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#09c}.user-root-image[_ngcontent-%COMP%]{width:25px;height:25px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/shared/user-info/user-info.component.scss.shim.ngstyle.js.pre-build-optimizer.js